import { sdkReady } from "./sdk"

export const collect = async (
    event: string,
    properties?: Record<string, unknown>,
) => {
    const sdk = await sdkReady()
    sdk.ETL.event(event, properties)
}

/**
 * 用户访问
 */
export const collectUserView = () => collect("user_view")

/**
 * 首次完成新手引导
 */
export const collectFinishGuide = () => collect("first_watch_tutorial_initial")

/**
 * 开始游戏
 * @param gameStartTs 关卡开始时间
 */
export const collectStart = (gameStartTs: number) =>
    collect("mini_game_start", { game_start_ts: gameStartTs })

/**
 * 进入地图
 * @param gameStartTs 关卡开始时间
 * @param gameStage 当前所在阶段
 */
export const collectStageStart = (gameStartTs: number, gameStage: string) =>
    collect("mini_game_stage_start", {
        game_start_ts: gameStartTs,
        game_stage: gameStage,
    })

/**
 * 到达地图终点
 * @param gameStartTs 关卡开始时间
 * @param gameStage 当前所在阶段
 */
export const collectStageFinish = (gameStartTs: number, gameStage: string) =>
    collect("mini_game_stage_finish", {
        game_start_ts: gameStartTs,
        game_stage: gameStage,
    })

/**
 * 解锁 CG 图片
 * @param gameStartTs 关卡开始时间
 * @param collectionId 图片 ID
 */
export const collectCollectionUnlock = (
    gameStartTs: number,
    collectionId: string,
) =>
    collect("game_collection_unlock", {
        game_start_ts: gameStartTs,
        collection_id: collectionId,
    })

/**
 * 点击分享按钮
 * @param buttonName 按钮名称
 * @param cgId 图片 ID
 */
export const collectClickShareButton = (buttonName: string, cgId?: string) =>
    collect("share_button", {
        button_name: buttonName,
        ...(cgId ? { cg_id: cgId } : {}),
    })

/**
 * 分享到社交媒体
 * @param channel 分享方式
 */
export const collectSocialMediaShare = (
    target: "game" | "recall",
    channel: string,
) => collect("social_media_share", { target, channel })

/**
 * 进入回归专题页面
 */
export const collectJumpToRecall = () => collect("jumpto_recall")

/**
 * 完成抽奖
 * @param result 抽奖结果
 */
export const collectLottery = (target: "game" | "recall", virtual: boolean) =>
    collect("lottery", {
        target,
        result: virtual ? "virtual_items" : "material_items",
    })

/**
 * 邀请码绑定成功 （回归）
 * @param inviteCode 绑定成功的邀请码
 * @param inviterUid 邀请人 UID
 */
export const collectRecallInviteSuccess = (
    inviteCode: string,
    inviterUid: string,
) =>
    collect("invite_success", {
        invite_code: inviteCode,
        inviter_uid: inviterUid,
    })

/**
 * 成功领取对应任务的奖励 （回归）
 * @param missionId 任务编号
 */
export const collectRecallMissionConfirm = (missionId: string) =>
    collect("mission_confirm", { mission_id: missionId })

/**
 * 调起分享页面 （回归）
 */
export const collectRecallShare = (target?: string) =>
    collect("event_share", { target })
